import { Schema as S } from "effect";
//  Can be either a prefixed price id or a string to match weird arbitrary stripe id types that seems to still exist
export const Schema = S.Union(S.TemplateLiteral(S.Literal("price_"), S.String), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/PriceId",
    description: "The id of the price in Stripe",
    examples: [
        "price_1234567890"
    ]
}));
export const make = (priceId)=>S.decodeUnknown(Schema)(priceId);
export const makeUnsafe = (priceId)=>priceId;
